import { msg } from '~/utils/validation';
import { z } from 'zod';

export const schema = z
  .object({
    name: z
      .string()
      .min(1, { message: msg.required })
      .max(100, { message: 'Namnet får inte vara längre än 100 tecken' }),
    competition_type: z.coerce.number({ message: msg.required }),
    age_categories: z.array(z.number()).min(1, { message: msg.required }),
    scoring_system: z.enum(['IPFGL', 'IPFGL_MALE', 'IPF', 'IPF_MALE', 'WILKS', 'WILKS_MALE', 'DOTS', 'DOTS_MALE'], {
      message: msg.required,
    }),
    nomination_start_date: z.string().date(msg.date),
    nomination_end_date: z.string().date(msg.date),
    gender: z.enum(['M', 'F', 'B'], { message: msg.required }),
    lifters_per_team: z.coerce.number().int().min(0),
    reserve_slots: z.coerce.number().int().min(0).default(0),
    min_female_lifters: z.coerce.number().int().min(0).default(0),
    min_male_lifters: z.coerce.number().int().min(0).default(0),
  })
  // Ensure the nomination period ends on or after it starts
  .refine(
    ({ nomination_start_date, nomination_end_date }) =>
      new Date(nomination_end_date) >= new Date(nomination_start_date),
    {
      message: 'Nomineringens slutdatum kan inte vara innan startdatumet',
      path: ['nomination_end_date'],
    }
  );

export type Schema = z.infer<typeof schema>;
